module.exports = __webpack_public_path__ + "img/slide_5.1373a944.webp";